module.exports = __webpack_public_path__ + "static/media/Crouch End Alcoves 7.407843d9.jpg";